// extracted by mini-css-extract-plugin
export default {"container":"SearchFiltersInput_container__C+gcF","input":"SearchFiltersInput_input__w+czL","icon":"SearchFiltersInput_icon__+idoO"};